// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Paging_pagination__1kwJd","total":"Paging_total__3S0pM"};